import React from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Column } from 'components/atoms';
import { Cities,SectionHeader } from 'components/molecules';
import { getNearbyCities } from 'store/selectors/getNearbyFacilities';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import './StorageNearYou.scss'
import { stateWiseCities } from 'utils/data/PSPCities';
import { StorageNearYouData } from 'pages/StyleGuidePage/nearbyCities';
export const enhance = compose(
	connect((state) => ({
		nearbyCities: getNearbyCities(state),
		geolocation: state.user.geolocation,
	}))
);

export function StorageNearYou({geolocation, nearbyCities}) {
	const { title, image, nearByDetectedCities, statesLink } = StorageNearYouData;
	const citiesByState = stateWiseCities.find(
		(stateInfo) => stateInfo.abbreviation === geolocation.region || stateInfo.state === geolocation.region
	);
	const nearByCitiesData = {
		...nearByDetectedCities,
		title: nearByDetectedCities.title + geolocation.city,
		cities: nearbyCities
			.map((item) => ({
				...item,
				name: `${item.city}, ${item.state}`,
				slug: item.url,
			}))
			.slice(0, 7),
	};
	
	const citiesByStateData = citiesByState ? {
		...nearByDetectedCities,
		title: nearByDetectedCities.title + (citiesByState.state ?? citiesByState.abbreviation),
		cities: citiesByState.cities.slice(0, 7).map((city) => {
			const formattedCity = citiesByState?.abbreviation  ? `${city.name}, ${citiesByState.abbreviation}` : city.name;
			return {...city, name: formattedCity};
		}),
	} : null;
	
	const statesLinkData = {
		...statesLink,
		cities: statesLink.cities.slice(0, 7),
	};
    return (
		<section className="section-container storage-near-you">
			<Container>
				<SectionHeader
					image={image}
					title={title}
					titleProps={{
						className: 'nearby-cities-title'
					}}
					contentAlign="text-center"
				/>
				<Row>
					{nearByCitiesData && (
						<Column
						medium={12}
						large={4}
						>
							<Cities {...nearByCitiesData} />
						</Column>
					)}
					{citiesByStateData && (
						<Column
							medium={12}
							large={4}
						>
							<Cities {...citiesByStateData} />
						</Column>
					)}
					{statesLinkData && (
						<Column
						medium={12}
						large={4}
					>
					<Cities {...statesLinkData} />
					</Column>
					)}
				</Row>
			</Container>
		</section>
	);
}

StorageNearYou.propTypes = {
	title: PropTypes.string.isRequired,
	image: PropTypes.string,
	geolocation: PropTypes.object.isRequired,
	nearbyCities: PropTypes.arrayOf(PropTypes.object).isRequired,
	nearByDetectedCities: PropTypes.object.isRequired,
	statesLink: PropTypes.object.isRequired,
};

export default enhance(StorageNearYou);